module.exports = __webpack_public_path__ + "img/9e0485b.png";